<div class="top-bar-select">
    <span class="select-name">Partner:</span>
    <dui-select [control]="partnerControl" [options]="partnerList" placeholder="Select Partner">
    </dui-select>
</div>
